import { Renderer2 } from '@angular/core';

const download = (
  renderer: Renderer2,
  type: any,
  content: any,
  filename = ''
) => {
  const anchor = renderer.createElement('a');
  renderer.appendChild(document.body, anchor);

  renderer.setStyle(anchor, 'visibility', 'hidden');
  let url: string | null = null;

  if (type === 'csv') {
    renderer.setAttribute(
      anchor,
      'href',
      'data:text/csv;charset=utf-8,' + encodeURIComponent(content)
    );
    renderer.setAttribute(anchor, 'download', filename + '.csv');
  } else if (type === 'json') {
    renderer.setAttribute(
      anchor,
      'href',
      'data:text/json;charset=utf-8,' +
        encodeURIComponent(JSON.stringify(content))
    );
    renderer.setAttribute(anchor, 'download', filename + '.json');
  } else if (type === 'link') {
    renderer.setAttribute(anchor, 'href', content);
    if (filename) {
      renderer.setAttribute(anchor, 'download', filename);
    }
  } else if (type === 'img') {
    renderer.setAttribute(anchor, 'href', content);
    renderer.setAttribute(anchor, 'download', filename);
    renderer.setAttribute(anchor, 'target', '_blank');
  } else {
    url = URL.createObjectURL(content);
    renderer.setAttribute(anchor, 'href', url);
    renderer.setAttribute(anchor, 'download', filename);
  }

  setTimeout(() => {
    anchor.click();
    anchor.remove();
    if (url) {
      URL.revokeObjectURL(url);
    }
  }, 5);
};

export const ExportHelpers = {
  downloadLink: (renderer: Renderer2, link: string, filename = '') => {
    download(renderer, 'link', link, filename);
  },

  downloadBlob: (renderer: Renderer2, data: any, filename: string) => {
    download(renderer, 'blob', data, filename);
  },

  downloadCSV: (renderer: Renderer2, data: any, filename: string) => {
    download(renderer, 'csv', data, filename);
  },

  downloadJSON: (renderer: Renderer2, data: any, filename: string) => {
    download(renderer, 'json', data, filename);
  },

  downloadXLSX: (renderer: Renderer2, data: any, filename: string) => {
    download(renderer, 'xlsx', data, filename);
  },

  downloadImg: (renderer: Renderer2, data: any, filename: string) => {
    download(renderer, 'img', data, filename);
  },
};
